module.exports = { id: "check-rounded", url: "/build/app/img/symbols.svg#check-rounded", viewBox: "", toString: function() { return this.url; } };